import { render, staticRenderFns } from "./scim-managed-notice.vue?vue&type=template&id=13db4514"
import script from "./scim-managed-notice.vue?vue&type=script&lang=js"
export * from "./scim-managed-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports